import { render } from "./SnapAccessCardSkeleton.vue?vue&type=template&id=61533e5d&scoped=true"
const script = {}

import "./SnapAccessCardSkeleton.vue?vue&type=style&index=0&id=61533e5d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61533e5d"]])

export default __exports__